import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Button, GraphQLErrorMessage, Heading3, Input } from '@treams/treams-ui';

import { WorkspaceAdvanced } from './types';

export default function WorkspaceDisplayName(props: { workspace: WorkspaceAdvanced }) {
	const { t } = useTranslation();
	const [displayName, setDisplayName] = useState(props.workspace.displayName ?? '');
	const [update, { loading, error }] = graphql.useUpdateWorkspaceDisplayNameMutation();

	useEffect(() => {
		setDisplayName(props.workspace.displayName ?? '');
	}, [props.workspace.displayName]);

	const save = useCallback(async () => {
		try {
			await update({
				variables: {
					input: {
						workspaceID: props.workspace.id,
						displayName,
					},
				},
			});
		} catch {
			// Error is handled by the error state from the mutation hook
		}
	}, [update, props.workspace.id, displayName]);

	return (
		<Box flexGrow={1} flexBasis={0} mt="30px">
			<Heading3 mb={2}>{t('settings.workspaces.displayName.label')}</Heading3>
			{error && (
				<Box mb={2}>
					<GraphQLErrorMessage error={error.graphQLErrors?.[0] ?? error} />
				</Box>
			)}
			<Flex>
				<Input
					value={displayName}
					onChange={setDisplayName}
					placeholder={t('settings.workspaces.displayName.placeholder')}
					flexGrow={1}
					mr={2}
				/>
				<Button
					onClick={save}
					small
					title={t('common.save')}
					type="primary"
					flexGrow={0}
					flexShrink={0}
					disabled={
						loading || !displayName.trim() || displayName === (props.workspace.displayName ?? '')
					}
				/>
			</Flex>
		</Box>
	);
}
